import type {
  RouteLocationNormalizedGeneric,
  RouteLocationRaw,
} from 'vue-router'
import { buildSwitchUrl } from '~/utils/routes'

/**
 * Composable to generate localized paths for different language versions
 * Adds the locale prefix to URLs (e.g., /de/shop/product, /en/shop/product)
 *
 * @returns Function that transforms a URL to a specific locale
 *
 * @example
 * const targetPath = useTargetPath()
 * targetPath('/shop/product', 'de') // Returns '/de/shop/product'
 * targetPath('/shop/product') // Returns '/fr/shop/product' (if fr current locale)
 */
export function useTargetPath() {
  const nuxt = useNuxtApp()
  const i18n = nuxt.$i18n

  return (
    url: RouteLocationRaw | RouteLocationNormalizedGeneric,
    targetLocale?: string
  ): string => {
    const locale = targetLocale ?? i18n.locale.value
    const allowedLocales = i18n.localeCodes.value

    return buildSwitchUrl(locale, allowedLocales, url)
  }
}
